module.exports = __webpack_public_path__ + "static/img/update_password.7340bf47.svg";